import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import ForageLogo from "./ForageLogo";

export default function Sidebar(){

  const navigate = useNavigate();

  async function handleLogout(){
    try{
      await signOut(auth);
      navigate("/");
    } catch(err){
      console.error("Logout failed:", err);
    }
  }

  return(

    <div className="sidebar">

      <div className="sidebarBrand">
        <div className="sidebarBrandMark">
          <ForageLogo size={26} color="#c8dba8" />
          <h2>Forage</h2>
        </div>
        <div className="sidebarTagline">meal planning, simplified</div>
      </div>

      <nav>
        <NavLink to="/"         end>Dashboard</NavLink>
        <NavLink to="/meals"       >Meals</NavLink>
        <NavLink to="/planner"     >Planner</NavLink>
        <NavLink to="/cook"        >Cook with My Ingredients</NavLink>
        <NavLink to="/grocery"     >Groceries</NavLink>
        <NavLink to="/profile"     >Profile</NavLink>
      </nav>

      <div className="sidebarLogout">
        <button onClick={handleLogout}>Log out</button>
      </div>

    </div>

  );

}
